import Card from "../../../../components/card/card";
import ManualLineups from "../../../../components/manual-lineups/manual-lineups";
import Tabs from "../../../../components/tabs/tabs";
import { useBroadcastPortalContext } from "../../broadcast-portal.context";
import type { TabIds } from "../../broadcast-portal.types";
// import FormationsModule from "../formations-module/formations-module";
import TeamList from "./components/team-list/team-list";
import * as CSS from "./teams-module.styles";
import { useTeamsModule } from "./use-teams-module";

const TeamsModule = () => {
	const {
		broadcastId,
		fixtureId,
		homeTeam,
		awayTeam,
		lineups,
		substitutions,
		cards,
		goalScorers,
		fetchingLineups,
		lineupFetchMsg,
		lastLineupAttempt,
		lineupRetryRef,
		handleFetchLineups,
	} = useTeamsModule();

	const { activeTeam, setActiveTeam } = useBroadcastPortalContext();

	return (
		<CSS.TeamsModule>
			<Card
				title="Teams"
				header={
					<Tabs
						activeTab={activeTeam}
						onChange={(id) => setActiveTeam(id as TabIds)}
						items={[
							{ id: "homeTeam", label: homeTeam || "Home" },
							{ id: "awayTeam", label: awayTeam || "Away" },
						]}
					/>
				}
			>
				{fixtureId && !lineups && (
					<div>
						<button
							type="button"
							onClick={handleFetchLineups}
							disabled={fetchingLineups}
						>
							{fetchingLineups
								? "Fetching…"
								: lineupRetryRef.current
									? "Retrying…"
									: "Fetch Lineups"}
						</button>
						{lineupFetchMsg && <span> {lineupFetchMsg}</span>}
						{lastLineupAttempt && (
							<span
								style={{ marginLeft: 8, color: "#888", fontSize: "0.85em" }}
							>
								Last tried {lastLineupAttempt.toLocaleTimeString()}
							</span>
						)}
						{broadcastId && (
							<ManualLineups
								broadcastId={broadcastId}
								homeTeam={homeTeam}
								awayTeam={awayTeam}
							/>
						)}
					</div>
				)}

				<div style={{ marginTop: "1rem" }}>
					{lineups && activeTeam === "homeTeam" && (
						<TeamList
							team={lineups.home}
							subs={substitutions.filter((s) => s.team === "home")}
							cards={cards.filter((c) => c.team === "home")}
							scorers={goalScorers}
						/>
					)}
					{lineups && activeTeam === "awayTeam" && (
						<TeamList
							team={lineups.away}
							subs={substitutions.filter((s) => s.team === "away")}
							cards={cards.filter((c) => c.team === "away")}
							scorers={goalScorers}
						/>
					)}
				</div>
				{/* <FormationsModule
					fixtureId={fixtureId}
					activeTeam={activeTeam}
					homeTeam={homeTeam}
					awayTeam={awayTeam}
				/> */}
			</Card>
		</CSS.TeamsModule>
	);
};

export default TeamsModule;
